<div class="modal-inner">
    <h1>Kies een project</h1>
    <input [formControl]="fcProjectSearch" placeholder="Zoeken in projecten" />
    <div class="results">
        @if (searching) {
            <div class="result text-center">aan het zoeken...</div>
        }
        @for (project of projects; track project) {
            <div class="result" (click)="selectProject(project)">
                <strong>{{ project.afas_project_id }}</strong> {{ project.name }}
            </div>
        }
    </div>
    <div class="buttons">
        <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
    </div>
</div>
